// Issue Encountered category → subcategory options (mail routing is category-driven on backend).
export const ISSUE_DEPARTMENTS = [
  { id: 'Sales', name: 'Sales' },
  { id: 'Client', name: 'Client' },
  { id: 'SCM', name: 'SCM' },
  { id: 'Partner', name: 'Partner' },
  { id: 'Tech', name: 'Tech' },
  { id: 'Others', name: 'Others' },
  { id: 'OPS', name: 'OPS' },
];

export const ISSUE_SUBCATEGORIES_BY_DEPT = {
  Sales: [
    { id: 'Payment Pending', name: 'Payment Pending' },
    { id: 'Under Construction', name: 'Under Construction' },
    { id: 'BRD & KT Pending', name: 'BRD & KT Pending' },
    { id: 'Others', name: 'Others' },
  ],
  Client: [
    { id: 'Client Internal Dispute', name: 'Client Internal Dispute' },
    { id: 'Power & Internet', name: 'Power & Internet' },
    { id: 'Layout Approval Pending', name: 'Layout Approval Pending' },
    { id: 'Location Issue', name: 'Location Issue' },
    { id: 'Others', name: 'Others' },
  ],
  SCM: [
    { id: 'Material Delay', name: 'Material Delay' },
    { id: 'Material Faulty', name: 'Material Faulty' },
    { id: 'Material Damaged', name: 'Material Damaged' },
    { id: 'Material Missing', name: 'Material Missing' },
    { id: 'Others', name: 'Others' },
  ],
  Partner: [
    { id: 'Manpower Issue', name: 'Manpower Issue' },
    { id: 'Payment Dispute', name: 'Payment Dispute' },
    { id: 'Others', name: 'Others' },
  ],
  Tech: [
    { id: 'Configuration Pending', name: 'Configuration Pending' },
    { id: 'ANPR Issue', name: 'ANPR Issue' },
    { id: 'Fastag Charging Issue', name: 'Fastag Charging Issue' },
    { id: 'Others', name: 'Others' },
  ],
  // Matrix has no named subcategories; keep a single option so field stays mandatory.
  Others: [{ id: 'Others', name: 'Others' }],
  OPS: [{ id: 'Others', name: 'Others' }],
};

export const getIssueSubcategories = (dept) =>
  ISSUE_SUBCATEGORIES_BY_DEPT[dept] || [];
